export default __webpack_public_path__ + "static/media/login-bg.7593b671.jpg";